/* src/app/modules/print-cards/components/cards/backgrounds/post-cards-4x6/doug-shelf-talker-post-card-background/doug-shelf-talker-post-card-background.component.scss */
:host {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: stretch;
  box-sizing: border-box;
}
:host .main-content {
  flex: 1;
}
:host .main-content .print-card-background-asset {
  height: 100%;
  width: 100%;
}
/*# sourceMappingURL=doug-shelf-talker-post-card-background.component.css.map */
